'use client';

import { cn } from '@/lib/utils';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Box } from '@shopify/polaris';

const NavigationItem = ({ href, icon: Icon, children }) => {
  const pathname = usePathname();

  return (
    <Box paddingInline="300">
      <Link
        href={href}
        className={cn(
          'flex items-center gap-2 rounded-lg px-3 py-1 font-semibold text-[var(--p-color-text)] no-underline transition-all',
          pathname === href
            ? 'bg-[var(--p-color-nav-bg-surface-selected)]'
            : 'hover:bg-[var(--p-color-nav-bg-surface-hover)]'
        )}
      >
        {Icon && <Icon className="h-5 w-5" />}
        {children}
      </Link>
    </Box>
  );
};

export default NavigationItem;
